import { type Task, type TaskStatus } from '@/types/Task'
import { createTask } from '@/factories/taskFactory'

export const TaskModel = {
  create: createTask,

  validate(task: Task): boolean {
    return !!task.title && !!task.status && this.isValidStatus(task.status)
  },

  isValidStatus(status: string): status is TaskStatus {
    return ['todo', 'doing', 'done', 'cancelled'].includes(status)
  },

  getStatusSeverity(status: TaskStatus): string {
    const map: Record<TaskStatus, string> = {
      todo: 'info',
      doing: 'warning',
      done: 'success',
      cancelled: 'danger',
    }
    return map[status] || 'info'
  },

  getStatusLabel(status: TaskStatus): string {
    const map: Record<TaskStatus, string> = {
      todo: 'To Do',
      doing: 'In Progress',
      done: 'Done',
      cancelled: 'Cancelled',
    }
    return map[status] || status
  },

  isOverdue(task: Task): boolean {
    if (!task.dueAt) return false
    const now = new Date()
    const dueDate = new Date(task.dueAt)
    return dueDate < now && task.status !== 'done' && task.status !== 'cancelled'
  },

  getDueDateStatus(task: Task): 'overdue' | 'today' | 'upcoming' | 'none' {
    if (!task.dueAt) return 'none'

    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const dueDate = new Date(task.dueAt)
    const dueDay = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate())

    if (dueDay < today) return 'overdue'
    if (dueDay.getTime() === today.getTime()) return 'today'
    return 'upcoming'
  },

  sortByDueDate(tasks: Task[], ascending = true): Task[] {
    return [...tasks].sort((a, b) => {
      if (!a.dueAt) return ascending ? 1 : -1
      if (!b.dueAt) return ascending ? -1 : 1
      return ascending
        ? new Date(a.dueAt).getTime() - new Date(b.dueAt).getTime()
        : new Date(b.dueAt).getTime() - new Date(a.dueAt).getTime()
    })
  },
}
